<template>
  <div class="flex-space align-center text-left">
    <div
      class="cname"
      v-for="(str, index) in splitStr(item.terminals)"
      :key="index"
      >{{ str }}</div
    >
    <popup
      v-if="$store.envs.trace && isImport(item)"
      name=""
      className="el-icon-search bold"
      componentPath="pages/traces/widget"
      width="960px"
      :pivot-y="0"
      :options="{ id: item.id, type: 'Container', name: item.container_no }"
    />
  </div>
</template>

<script>
export default {
  name: "order-status-terminals",
  props: {
    item: Object,
    options: Object,
  },
};
</script>
